import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { actions } from '../../actions';

/**
 * @return {null}
 */
function Notifier(props) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { notification } = props;

    const displayed = useRef(new Set());

    const removeSnackbar = (id) => {
        displayed.current.delete(id);
    };

    const addSnackbar = (id) => {
        displayed.current.add(id);
    };

    useEffect(() => {
        notification.forEach(({ key, message, options }) => {
            if (displayed.current.has(key)) return;

            // Check if message contains newlines - if so, render as component
            const messageComponent =
                typeof message === 'string' && message.includes('\n') ? (
                    <Typography component='div' sx={{ whiteSpace: 'pre-line' }}>
                        {message}
                    </Typography>
                ) : (
                    message
                );

            // Add close button for persistent notifications (warnings)
            const snackbarOptions = {
                key,
                ...options,
                onExited: (event, key) => {
                    props.removeNotification(key);
                    removeSnackbar(key);
                },
            };

            // Add close button action for warnings and errors (persistent notifications)
            if (options.variant === 'warning' || options.variant === 'error' || options.persist) {
                snackbarOptions.action = (snackbarId) => (
                    <IconButton
                        size='small'
                        aria-label='close'
                        color='inherit'
                        onClick={() => {
                            closeSnackbar(snackbarId);
                            props.removeNotification(snackbarId);
                            removeSnackbar(snackbarId);
                        }}
                    >
                        <CloseIcon fontSize='small' />
                    </IconButton>
                );
            }

            enqueueSnackbar(messageComponent, snackbarOptions);
            addSnackbar(key);
        });
    });

    return null;
}

const mapStateToProps = (state) => {
    return {
        notification: state.notification,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        removeNotification: (key) => dispatch(actions.notification.remove(key)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifier);
